import { FILE_NAME_MAX_LENGTH } from '@/modules/common/consts/max-length.ts';

export function uploadFilesByName<T extends { name: string }, TResult>(
  files: T[],
  upload: (file: T) => Promise<TResult>
) {
  let longNamesQueue = Promise.resolve();

  return Promise.allSettled(
    files.map((file) => {
      const run = () => upload(file);

      if (file.name.length <= FILE_NAME_MAX_LENGTH) {
        return Promise.resolve().then(run);
      }

      const result = longNamesQueue.then(run);
      longNamesQueue = result.then(
        () => undefined,
        () => undefined
      );
      return result;
    })
  );
}
